import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    details: (limit: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useBulkActionLimitToast.title?c=3oky6b1fg9fo3", defaultMessage: "Limit Reached" }));
                },
                enumerable: true,
                configurable: true
            },
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (limit: number): string => __intl__.intl().formatMessage({ id: "useBulkActionLimitToast.details?c=y3g1v1pfd5bf", defaultMessage: "Please try again with {limit} items or fewer." }, { limit: limit }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
